import { render, staticRenderFns } from "./FormGroupBox.vue?vue&type=template&id=a332ff90&scoped=true&"
import script from "./FormGroupBox.vue?vue&type=script&lang=js&"
export * from "./FormGroupBox.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupBox.vue?vue&type=style&index=0&id=a332ff90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a332ff90",
  null
  
)

export default component.exports